import { Injectable, Input } from '@angular/core';
import { FeatureSetDeclarationSettings } from '../backend-types/feature-set';
import { Ballot, Question, Statement } from '../ballot/backend-types';
import { BallotService } from '../ballot/ballot.service';

@Injectable({
  providedIn: 'root'
})
export class DeclarationService {

  text: string = ""
  required: boolean = false

  setDeclarationSettings(settings?: FeatureSetDeclarationSettings) {
    if (settings) {
      this.required = settings.declarationMandatory
      this.text = settings.declarationText
    } else {
      this.required = false
      this.text = "<h1 id=\"main-title\" class=\"vtz-h1 vtz-h1--small\" id=\"main-title\" i18n=\"Declration statement title\">Declaration of Qualification</h1><p class=\"vtz-text vtz-text--tiny vtz-text--100\">I hereby affirm that I am on the Voters’ List, I am eligible to vote in the 2022 Election and I have not already voted in this election. I make this declaration conscientiously believing it to be true.</p>"
    }
  }

  constructor() { }

  generateDeclinedBallot(ballot: Ballot): Ballot {
    const questions: Question[] = []
    const question = ballot.voteEventData.questions.find(q => q.statements.find(s => s.declineToVoteContest) !== undefined)
    if (question) {
      const statements = question.statements.filter(s => s.declineToVoteContest)
      questions.push( new Question(
        question.description ?? "",
        question.questionId,
        statements,
        question.isRCV
      ))
    }
    const marked: Ballot = {
      eventId: ballot.eventId,
      voteEventData: {
        description: ballot.voteEventData.description,
        questions: questions
      },
      eventCreation: ballot.eventCreation,
      eventActivation: ballot.eventActivation,
      eventExpiration: ballot.eventExpiration,
      contest_list: [],
    }
    return marked
  }
}
